import { Button } from "../../../components/button";
import { Input } from "../../../components/input";

type OrganizationsToolbarProps = {
  keyword: string;
  onKeywordChange: (value: string) => void;
  onRefresh: () => void;
};

export function OrganizationsToolbar({
  keyword,
  onKeywordChange,
  onRefresh,
}: OrganizationsToolbarProps) {
  return (
    <div className="mb-4 flex flex-wrap gap-3">
      <Input
        value={keyword}
        onChange={(event) => onKeywordChange(event.target.value)}
        placeholder="Search organizations"
        className="max-w-md"
      />
      <Button variant="outline" onClick={onRefresh}>
        Refresh
      </Button>
    </div>
  );
}
